module.exports = __webpack_public_path__ + "img/logo-gif-sub-brands-products.94913eb9.gif";